export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'record',
                    modifier: (value, row) => {
                        if (row?.status?.id == 145 || row?.status?.id == 142) {
                            return `<a href="/accreditations/applications/${row.id}" target="_blank">${value || ''}</a>`;
                        } else {
                            return value;
                        }    
                    }
                },
                {
                    title: this.$t('area'),
                    type: 'custom-html',
                    key: 'accreditation_area',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('activity'),
                    type: 'custom-html',
                    key: 'accreditation_activity',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('type'),
                    type: 'custom-html',
                    key: 'accreditation_type',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: 'Gestor Técnico',
                    type: 'custom-html',
                    key: 'technical',
                    modifier: (value) => {
                        return value ? `${value.first_name} ${value.last_name}` : '';
                    }
                },
                {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    modifier: (value) => {
                        let className;
                        let status;

                        if (value.code == '100' || value.code == '102' || value.code == '110') {
                            className = 'warning';
                            status = value.name;
                        } else if (['112', '116', '109'].includes(value.code)) {
                            className = 'danger';
                            status = value.name;
                        } else {
                            className = 'success';
                            status = value.name;
                        }

                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                },
                {
                    title: 'Días Disponibles',
                    type: 'custom-html',
                    key: 'accreditation_time',
                    modifier: (value) => {
                        let tmp;
                        if (value) {
                            if (value.remaining_days > 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 0) {
                                tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
                            }
                        }
                        return tmp;
                    }
                },
                {
                    title: this.$t('creation_date'),
                    type: 'custom-html',
                    key: 'created_at',
                    modifier: (value) => {
                        return moment(String(value)).format('YYYY-MM-DD hh:mm');
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}